import { AppBar, Box, IconButton, Toolbar, Typography } from '@mui/material';
import { useRouter } from 'next/router';
import { FormattedMessage, useIntl } from 'react-intl';

import { accountRoutes, ticketRoutes } from 'constants/navigation.constants';
import { Routes } from 'constants/routes.constants';

import { AffiliateHeadingLogo } from 'components/@affiliate/AffiliateLogo';
import LanguagePickerButton from 'components/@common/LanguagePickerButton';
import LinkUnstyled from 'components/@common/LinkUnstyled';
import Icon from 'components/@icons/Icon';
import HideOnScroll from 'components/@navigation/HideOnScroll';
import LogoNofomo from 'components/@navigation/LogoNofomo';

const DesktopNavigation = () => {
  const intl = useIntl();
  const { pathname } = useRouter();

  return (
    <Box sx={{ display: { xs: 'none', md: 'block' } }}>
      <HideOnScroll>
        <AppBar color="default">
          <Toolbar sx={{ pr: 2, pl: 1, justifyContent: 'space-between' }}>
            <Box
              aria-label={intl.formatMessage({
                id: 'navigation.home',
                defaultMessage: 'Home',
              })}
              component={LinkUnstyled}
              href={Routes.Home}
              sx={{
                display: 'flex',
                alignItems: 'center',
                p: 1,
              }}
            >
              <LogoNofomo />
              <AffiliateHeadingLogo />
            </Box>
            <Box sx={{ display: 'flex', gap: 1.5 }}>
              <IconButton
                variant="filled"
                color={
                  ticketRoutes.includes(pathname) ? 'secondary' : 'inherit'
                }
                sx={{ gap: 1 }}
                size="small"
                component={LinkUnstyled}
                href={Routes.AccountTickets}
              >
                <Icon name="Ticket" color="text.secondary" />
                <Typography
                  variant="small"
                  sx={{
                    color: ticketRoutes.includes(pathname)
                      ? 'secondary'
                      : 'text.secondary',
                    mt: '2px',
                    fontWeight: 700,
                  }}
                >
                  <FormattedMessage id="account.tickets.label" />
                </Typography>
              </IconButton>

              <IconButton
                variant="filled"
                sx={{ gap: 1 }}
                color={
                  accountRoutes.includes(pathname) ? 'secondary' : 'inherit'
                }
                size="small"
                component={LinkUnstyled}
                href={Routes.Account}
              >
                <Icon name="Profile" color="text.secondary" />
                <Typography
                  mt="2px"
                  variant="small"
                  color={
                    accountRoutes.includes(pathname)
                      ? 'secondary'
                      : 'text.secondary'
                  }
                  fontWeight={700}
                >
                  <FormattedMessage id="account.profile.label" />
                </Typography>
              </IconButton>
              <LanguagePickerButton />
            </Box>
          </Toolbar>
        </AppBar>
      </HideOnScroll>

      {/* preserve space for the fixed header */}
      <Toolbar />
    </Box>
  );
};

export default DesktopNavigation;
